import React from "react";
import formats from "../../utils/formats";
import { useTranslation } from "react-i18next";

export default function DeliveryCheckoutValue(props) {
    const { restaurant, total, coupon, deliveryCost } = props;

    const { t } = useTranslation();

    const [newtotal, setNewTotal] = React.useState();

    const hasCoupon = coupon && coupon.accepted;
    const hasDeliveryFee = restaurant.orders.delivery.fee > 0;
    const hasCostIncrease = deliveryCost?.cost_increase !== undefined && deliveryCost?.cost_increase > 0;
    const constIncrease = hasCostIncrease ? deliveryCost.cost_increase : 0;
    const totalWithFee = hasDeliveryFee ? total + restaurant.orders.delivery.fee + constIncrease : total;

    React.useEffect(() => {
        if (coupon) {
            if (String(coupon.restaurantAccepted) === String(restaurant.id)) {
                const discountedTotal = formats.formatPercentageToPrice(coupon.discount, total);
                setNewTotal(discountedTotal);
            }
        }
    }, [coupon, restaurant.id, total]);

    return (
        <div>
            {hasCoupon ?
                <p className="flex flex-col my-6 py-4 p-4 text-center">
                    <div className="pb-2">{t("deliveryform.checkoutvalue.div_1", { total: formats.formatPrice(total) })} </div>
                    <div className="text-sm text-mycia-red">-{coupon.discount}%</div>
                    <div className="pb-2">{t("deliveryform.checkoutvalue.div_2")} <span className="font-bold">{formats.formatPrice(newtotal)}</span></div>
                    <hr className="pb-2" />
                    {hasCostIncrease ?
                        <div>
                            <p className="pb-2">{t("deliveryform.checkoutvalue.div_5")} <span className="font-bold">{formats.formatPrice(deliveryCost.cost_increase)}</span></p>
                            <hr className="pb-2" />
                        </div> : null}
                    <span className="text-mycia-green">
                        {t("deliveryform.checkoutvalue.div_3")} <span className="font-bold">{formats.formatPrice(newtotal + restaurant.orders.delivery.fee + constIncrease)}</span>
                    </span>
                    <div className="text-black">{t("deliveryform.checkoutvalue.div_4", { fee: restaurant.orders.delivery.fee })}</div>
                </p> :
                <p className="my-6 py-4 text-center font-bold">
                    {t("deliveryform.checkoutvalue.p_1", { totalPlusFee: totalWithFee, fee: restaurant.orders.delivery.fee })}
                </p>}
        </div>
    );
}
